import {
  Typography,
  TextField,
  Button,
  Box,
  Alert,
  CircularProgress,
} from "@mui/material";
import { useUploadCircle } from "../Hooks/useUploadCircle";
import { useCircleTasks } from "../../common/contexts/CircleTaskProvider";
import CircleTask from "../Components/CircleTask";

const UploadToCirclePage = () => {
  const { personId, loading, error, handleSubmit, handleInputChange } =
    useUploadCircle();
  const { getAllTasks } = useCircleTasks();

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Upload to Circle
      </Typography>
      <Typography variant="body1" component="h1" gutterBottom>
        Enter the NATIONBUILDER ID of the person to upload to Circle.
      </Typography>

      <Box sx={{ maxWidth: 400, mt: 3 }}>
        <TextField
          fullWidth
          label="NATIONBUILDER ID"
          value={personId}
          onChange={handleInputChange}
          placeholder="Enter NATIONBUILDER ID"
          type="text"
          slotProps={{
            input: {
              inputMode: "numeric",
            },
            htmlInput: { maxLength: 12 },
          }}
          margin="normal"
        />

        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={!personId.trim() || loading}
          sx={{ mt: 2 }}
        >
          {loading ? <CircularProgress size={24} /> : "Submit"}
        </Button>

        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
      </Box>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
          mt: 2,
        }}
      >
        {getAllTasks()
          .reduce<React.ReactNode[][]>((rows, task, idx) => {
            if (idx % 3 === 0) rows.push([]);
            rows[rows.length - 1].push(
              <Box key={task.id} sx={{ minWidth: 300, flex: "1 0 300px" }}>
                <CircleTask
                  personId={task.id}
                  taskResult={task.task_result ?? null}
                />
              </Box>,
            );
            return rows;
          }, [])
          .map((row, rowIdx) => (
            <Box
              key={rowIdx}
              sx={{
                display: "flex",
                gap: 2,
                width: "100%",
                mb: 2,
              }}
            >
              {row}
            </Box>
          ))}
      </Box>
    </Box>
  );
};

export default UploadToCirclePage;
